// App.jsx
import React from "react";
import "./App.css";
import "./Responsive.css";
import { BrowserRouter as Router } from "react-router-dom";
import RoutesComponent from "./RoutesComponent";
import ScrollToTop from "./components/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProfileProvider } from "../src/context/ProfileContext";
import { AvatarProvider } from "../src/context/AvatarContext";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <ProfileProvider>
        <AvatarProvider>
          <RoutesComponent />
          <ToastContainer />
        </AvatarProvider>
      </ProfileProvider>
    </Router>
  );
}

export default App;
